<template>
  <div>
    <v-collapse-wrapper :active="true">
      <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
           v-collapse-toggle>
        <h3>{{$t('form.lot.participation-in-lot-discussion')}}</h3>
      </div>

      <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
        <template v-for="(comment, idx) in lot.comments">
          <comment-view :lot="lot" :serial="idx + 1" :comment="comment"></comment-view>
        </template>

        <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_COMMENTS && lot.isCommentAllowed">
          <new-comment-form :lot="lot"></new-comment-form>
        </template>
        <p v-else-if="!lot.isCommentAllowed">
          {{$t('form.lot.lot-discussion-is-closed')}}
        </p>
      </div>
    </v-collapse-wrapper>
  </div>
</template>

<script>
  import CommentView from './discussion/Comment'
  import NewCommentForm from './discussion/NewCommentForm'

  export default {
    props: {
      lot: Object
    },

    components: {
      NewCommentForm,
      CommentView
    }
  }
</script>

<style scoped>

</style>
